export default __webpack_public_path__ + "images/6S.8f921ae.png";